import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const HRAExemptAllowanceHint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<p className="leading-para text-greyDark text-start">
					Salaried individuals living in rented houses (paying rent) can claim the House Rent
					Allowance (HRA). If you do not live in rented accommodation, this allowance is fully
					taxable.To claim the HRA exemption, HRA must be part of your salary. If your employer does
					not provide you the HRA or if you are self employed, then you can claim the deduction
					under section 80GG. The amount of rent paid cannot be claimed as HRA Exemption directly.
					The HRA exemption shall be lower of the below 3 amounts1. Actual HRA received;2. 50% of
					[Basic Salary + Dearness Allowance] for those living in metro cities (40% for
					non-metros);or3. Actual rent paid less 10% of [Basic Salary + Dearness Allowance]Use the
					HRA Calculator to calculate the HRA exemption amount.Note: If you see any auto populated
					amount under HRA exemption, then it is captured from the Form 16 that you have uploaded.
					This value is not calculated by myTaxClub.
				</p>

				<img
					src={`${appConstants.basePath}/assets/images/hints/hra-exemption.png`}
					alt="HRA"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default HRAExemptAllowanceHint;
